export const API_ROUTES = {
  // public routes
  LOG_IN: '/onboarding/sign-in',
  GET_PERMISSIONS: '/get-admin-permission',

  // user routes
  GET_USERS: '/all-users',
  SEARCH_USER: '/search-user',
  GET_USER_BETS: '/get-user-bets',
  GET_USER_CASINO_BETS: '/get-user-casino-bets',
  GET_BET_BY_ID: '/retrieve-bet-details',
  EDIT_USER_PROFILE: '/edit-user-profile',
  EDIT_USER_WALLET: '/update-user-wallet',
  DELETE_USER: '/delete-user',
  CHANGE_USER_ACH: '/update-user-ach-status',
  SUSPEND_UNSUSPEND_USER: '/suspend-unsuspend-user',
  GET_TRANSACTION_HISTORY: '/get-user-transaction-history',
  GET_PAYMENT_INSTRUMENTS: '/fetch-user-bank-accounts',
  DELETE_ALL_PAYMENT_INSTRUMENTS: '/delete-user-bank-accounts',
  DELETE_SPECIFIC_PAYMENT_INSTRUMENT: '/delete-bank-from-bank-list',
  SEND_EMAIL_VERIFICATION: '/send-verification-code-to-email',
  EDIT_SINGLE_BET: '/settle-sportbook-bet',
  EDIT_PARLAY_BET: '/settle-parlay-bet',
  EDIT_GROUP_BET: '/settle-group-bet',
  GET_EVENT_CODES_LIST: '/get-event-codes-list',
  UPDATE_EVENT_CODE: '/update-event-code',
  GET_PLAID_STATUS_BY_DAY: '/get-plaid-status-by-day',
  ADD_EVENT_CODE: '/add-event-code',
  GET_USERS_TOU_STATUS: '/get-users-tou-status',
  USERS_DEPOSIT_ATTEMPTS: '/users-deposit-attempts',
  USERS_PERSONAL_LIMIT: '/users-personal-limit',
  UPDATE_USER_LOCKED_LIMIT: '/update-user-locked-limit',
  SET_USERS_PERSONAL_LIMIT: '/set-users-personal-limit',
  GIVE_USER_FREE_PICK: '/give-user-free-pick',
  GIVE_USER_PROFIT_BOOST: '/give-user-profit-boost',
  GET_ALT_ODDS: '/get-alt-odds',
  GET_ALT_ODDS_HISTORY: '/get-alt-odds-history',
  UPDATE_USER_APPSTORE_REVIEW_STATUS: '/update-user-appstore-review-status',
  UPDATE_USER_GAME_PASS_STATUS: '/update-user-game-pass-enabled-status',
  UPDATE_USER_GAME_PASS_PREMIUM_STATUS: '/update-user-game-pass-premium-status',
  UPDATE_USER_GLOBAL_CHAT_STATUS: '/update-user-global-chat-status',
  GET_MONTHLY_CHALLENGE_INFO: '/get-monthly-challenge-info',
  GET_WEEKLY_CHALLENGE_INFO: '/get-weekly-challenge-info',
  EDIT_TASK: '/edit-task',

  // kpi routes
  GET_SPORTRADAR_BET_METRICS: '/get-betting-metrics',
  REFRESH_SPORTRADAR_BET_METRICS: '/refresh-betting-metrics',
  GET_TOTAL_NUM_USERS: '/get-total-users',
  GET_TOTAL_EMAIL_VERIFIED: '/get-email-status',
  GET_TOTAL_PLAID_VERIFIED: '/get-plaid-status',
  GET_TOTAL_PURCHASES: '/get-total-purchases',
  GET_TOTAL_PRIZE_REDEMPTIONS: '/get-total-redemptions',
  GET_TOTAL_REVENUE: '/get-total-revenue',
  GET_TOTAL_REDEEMABLE_AMOUT: '/get-total-redeemable-amount',
  GET_TRANSACTIONS_BY_STATE: '/get-transactions-by-state',
  REFRESH_TRANSACTIONS_BY_STATE: '/refresh-transactions-by-state ',
  GET_EMAIL_STATUS_BY_DAY: '/get-email-status-by-day',
  GET_FREE_CASH_METRICS: '/get-free-cash-metrics',
  GET_PROFIT_BOOST_METRICS: '/get-profit-boost-metrics',
  GET_APPLE_PAY_PROVIDER_SETTINGS: '/get-apple-pay-provider-settings',
  UPDATE_APPLE_PAY_PROVIDER_SETTINGS: '/update-apple-pay-provider-setting',

  //Affiliate routes
  REFRESH_ADMIN_AFFILIATE_DATA: '/refresh-admin-affiliate-data',
  GET_ALL_REFERRAL_CODES: '/get-all-referral-codes',
  GET_FTD_LIST: '/get-ftd-list',
  GET_FTD_LIST_BY_DAY: '/get-ftd-list-by-day',
  TOTAL_YEAR_COMMISSION_PAIDOUT: '/total-year-commission-paidout',
  GET_AVG_CAC: '/get-avg-cac',
  ADMINS_TOTAL_COMMISSION_MONTHLY: '/admins-total-commission-month',
  GET_TOTAL_FTDS: '/get-total-ftds',
  GET_TOTAL_MONTHLY_FTDS: '/get-total-monthly-ftds',
  GET_TOTAL_MONTHLY_DEPOSIT_RATIO: '/total-monthly-deposit-ratio',
  GET_REFERRAL_STATS: '/get-referral-stats',
  ADMINS_TOTAL_REVENUE: '/admins-total-revenue',
  TOP_PERFORMERS_CURRENT_MONTH: '/top-performers-current-month',
  AVG_MONTHLY_LTV: '/avg-monthly-ltv',
  TOTAL_SIGNUPS_YEAR: '/total-signups-year',
  TOTAL_MONTHLY_SIGNUPS: '/total-monthly-signups',
  TOTAL_DEPOSIT_RATIO: '/total-deposit-ratio',
  AVG_MONTHLY_REVENUE: '/avg-monthly-revenue',
  ADMINS_TOTAL_COMMISSION_MONTH_BREAKDOWN:
    'admins-total-commission-month-breakdown',

  // admin routes
  CREATE_ADMIN: '/create-admin-user',
  EDIT_ADMIN: '/update-admin-group',
  GET_ADMINS: '/get-admins',
  DELETE_ADMIN: '/delete-admin',

  // whitelist routes
  WHITELIST_IP: 'whitelist-ip',

  // promotions routes
  FETCH_INITIAL_DEPOSIT_AND_REFERRER_VALUES:
    '/fetch-initial-deposit-and-referrer-values',
  UPDATE_INITIAL_DEPOSIT_AND_REFERRER_VALUES:
    '/update-initial-deposit-and-referrer-values',
  GET_USER_ACTIVE_BONUSES: '/get-user-active-bonuses',
  EXPIRE_USER_PROMOTION: '/expire-user-promotion',
  GET_PROMOTIONS_DASHBOARD: '/dashboard/promotion_management',

  // payments routes
  REDEMPTIONS_PENDING: '/redemptions-pending',
  TOTAL_PENDING_REDEMPTIONS_AMOUNT: '/total-pending-redemptions-amount',
  PENDING_REDEMPTIONS_TRIGGER: '/pending-redemptions-trigger',
  DELETE_SINGLE_PENDING_REDEMPTION: '/delete-single-pending-redemption',

  // reports routes
  LIST_DM_REPORTS: '/list-dm-reports',
  CLOSE_DM_REPORT: '/close-dm-report',

  // card details
  GET_CARD_DETAILS: '/get-card-details',
  DELETE_CARD_FROM_CARDS_LIST: '/delete-card-from-cards-list',
  DELETE_ALL_CARDS: '/delete-all-cards',

  // Feature Management - Casino
  GET_CASINO_GAMES: '/get-casino-games',
  TOGGLE_CASINO_GAME_STATUS: 'toggle-game-status-for-casino-entity',
  REMOVE_GAME_FROM_CASINO_ENTITY: 'remove-game-from-casino-entity',
  ADD_CASINO_ENTITY: 'add-casino-entity',
  ADD_GAME_IN_CASINO_ENTITY: 'add-game-in-casino-entity',
  TOGGLE_CASINO_ENTITY_STATUS: 'toggle-casino-entity-status',
  CHANGE_CASINO_ENTITY_ORDER: 'change-casino-entity-order',
  CHANGE_GAME_ORDER_FOR_CASINO_ENTITY: 'change-game-order-for-casino-entity',
  UPDATE_CASINO_GAME_THUMB: 'update-casino-game-thumb',
  GET_SPORTS_ORDERING: 'get-sports-ordering',
  GET_ENTITIES_BY_TYPE: 'get-entities-by-type',
  REORDER_ENTITIES: 'reorder-entities',
  PIN_ENTITY: 'pin-entity',
  UNPIN_ENTITY: 'unpin-entity',
  SET_ENTITY_ACTIVE_STATUS: 'set-entity-active-status',
  PIN_SHORTCUT: 'pin-shortcut',

  // Customer Support Controls
  GET_GLOBAL_VARIABLE: 'get-global-variable',
  SET_GLOBAL_VARIABLE: 'set-global-variable',

  // Manual Entries
  GET_MANAGERS: '/get-managers',
  GET_MANUAL_ENTRIES_ANALYTICS: '/get-manual-entries-analytics',
  GET_MANUAL_ENTRIES_PAGINATED: '/get-manual-entries-paginated',
  GET_SUPPORT_AGENTS: '/get-support-agents',

  // Transactions - Wallet
  GET_WALLET_TRANSACTIONS: '/get-wallets',
  GET_WALLET_TRANSACTIONS_OVERVIEW: '/get-transactions-overview',
  GET_WALLET_TRANSACTIONS_TABLE: '/get-transactions-table',

  // Sportsbook
  GET_SPORTSBOOK_OVERVIEW: '/get-sportsbook-overview',
  GET_TOTAL_EVENTS_DATA: '/get-events-status-counts',
  GET_BET_TIMING_ANALYSIS: '/get-bet-timing-analysis',
  GET_SPORTSBOOK_BETS_REPORT: '/get-sportsbook-table',
  GET_SPORTSBOOK_EVENTS_LIST: '/get-sportsbook-events-list',
  GET_MARGIN_BY_BET_TYPE: '/get-bet-type-margin-data',
  GET_LEAGUE_DISTRIBUTION_DATA: '/get-league-distribution-data',
  GET_TICKET_LENGTH_BREAKDOWN: '/get-ticket-length-pie-data',
  GET_SPORT_SELECTION_DISTRIBUTION: '/get-sports-pie-data',
  GET_TICKET_LENGTH_DISTRIBUTION: '/get-ticket-length-ggr-turnover-data',
  GET_USER_LIFECYCLE_TIME_SERIES: '/get-user-lifecycle-data',
  GET_SPORT_PERFORMANCE_DATA: '/get-sportsbook-performance-data',
  GET_MARGIN_DATA: '/get-margin-data',
  GET_USERS_BY_STATE: '/get-users-by-state-data',
  GET_USER_METADATA: '/user_metadata',
  GET_POPULAR_MARKETS: '/get-popular-markets',
  GET_LIVE_EVENT_ENTITIES: '/get-live-event-entities',

  // Transactions - Withdrawal Review
  GET_PENDING_TRANSACTIONS: '/get-pending-transactions',
  GET_PROCESSED_TRANSACTIONS: '/get-processed-transactions',
  GET_TRANSACTION_DETAILS: '/get-transaction-details',
  APPROVE_PENDING_TRANSACTION: '/approve-pending-transaction',
  DECLINE_PENDING_TRANSACTION: 'decline-pending-transaction',
  GET_WITHDRAWAL_RULES: '/get-withdrawal-rules',
  CREATE_WITHDRAWAL_RULE: '/create-withdrawal-rule',
  UPDATE_WITHDRAWAL_RULE: '/update-withdrawal-rule',
  ACTIVATE_WITHDRAWAL_RULE: '/activate-withdrawal-rule',
  DEACTIVATE_WITHDRAWAL_RULE: '/deactivate-withdrawal-rule',
  DELETE_WITHDRAWAL_RULE: '/delete-withdrawal-rule',

  // Top Leagues Management
  GET_TOP_LEAGUES_ORDERING: '/get-top-leagues-ordering',
  REORDER_TOP_LEAGUE_ENTITIES: '/reorder-top-league-entities',
  DELETE_TOP_LEAGUE: '/delete-top-league',
  CREATE_NEW_TOP_LEAGUE: '/create-new-top-league',
  GET_POTENTIAL_TOP_LEAGUES_AUTOCOMPLETE:
    '/get-potential-top-leagues-autocomplete',
  SET_TOP_LEAGUE_ENTITY_ACTIVITY_STATUS:
    '/set-top-league-entity-activity-status',
  GET_EVENTS_BY_TOP_LEAGUE: '/get-events-by-top-league',
  PIN_FEATURED_EVENT: '/pin-featured-event',
  UNPIN_FEATURED_EVENT: '/unpin-featured-event',

  // Poker
  GET_USER_POKER_STATS: '/get-user-poker-stats',
  GET_USER_POKER_GAMES: '/get-user-poker-games',
  GET_USER_POKER_GAME_HANDS: '/get-poker-game-hands',
  GET_POKER_HAND_DETAILS: '/get-poker-hand-details',

  // Event Details
  GET_EVENT_MARKETS: '/get-event-markets',
  GET_EVENT_DETAILS_KPI_BET_TYPES: '/get-event-details-kpi-bet-types',
  GET_EVENT_DETAILS_KPI_BET_ACTIVITY: '/get-event-details-kpi-bet-activity',
  GET_EVENT_DETAILS_KPI_BET_STATUS: '/get-event-details-kpi-bet-statuses',
  GET_EVENT_DETAILS_KPI_MARKET_TYPES: '/get-event-details-kpi-market-types',
  GET_EVENT_DETAILS_KPI_TABLE: '/get-event-details-kpi-table',
  GET_EVENT_DETAILS_KPI_DAILY_HISTOGRAM:
    '/get-event-details-kpi-daily-histogram',
  GET_EVENT_DETAILS_KPI_OVERVIEW: '/get-event-details-kpi-overview',
  GET_EVENT_DETAILS_KPI_USER_STATE_MAP: '/get-event-details-kpi-user-state-map',
  GET_EVENT_DETAILS_HEADER: '/get-event-details-header',
  GET_MARKETS_FILTERS: '/get-event-details-markets-data',
  GET_EVENT_DETAILS_DATA: '/get-event-details-markets-data',
  GET_EVENT_DETAILS_TABLE: '/get-event-details-table',

  // Feature Management - Event Markets
  GET_EVENT_MARKETS_SPORTS: '/get-event-markets-sport-list',
  GET_MARKET_ENTITIES_BY_TYPE: '/get-market-entities-by-type',
  REORDER_MARKET_ENTITIES: '/reorder-market-entities',
  CREATE_NEW_MARKET_TAB: '/create-new-market-tab',
  CREATE_NEW_MARKET_CARD: '/create-new-market-card',
  RENAME_MARKET: '/rename-market',
  DELETE_MARKET_CARD: '/delete-market-card',
  DELETE_MARKET_TAB: '/delete-market-tab',
  GET_SPORT_MARKETS_AUTOCOMPLETE: '/get-sport-markets-autocomplete',
};

export const SLASHLESS_API_ROUTES = {
  // public routes
  LOG_IN: 'onboarding/sign-in',
  GET_PERMISSIONS: 'get-admin-permission',

  // user routes
  GET_USERS: 'all-users',
  SEARCH_USER: 'search-user',
  GET_USER_BETS: 'get-user-bets',
  GET_BET_BY_ID: 'retrieve-bet-details',
  EDIT_USER_PROFILE: 'edit-user-profile',
  EDIT_USER_WALLET: 'update-user-wallet',
  DELETE_USER: 'delete-user',
  CHANGE_USER_ACH: 'update-user-ach-status',
  SUSPEND_UNSUSPEND_USER: 'suspend-unsuspend-user',
  GET_TRANSACTION_HISTORY: 'get-user-transaction-history',
  GET_PAYMENT_INSTRUMENTS: 'fetch-user-bank-accounts',
  DELETE_ALL_PAYMENT_INSTRUMENTS: 'delete-user-bank-accounts',
  DELETE_SPECIFIC_PAYMENT_INSTRUMENT: 'delete-bank-from-bank-list',
  SEND_EMAIL_VERIFICATION: 'send-verification-code-to-email',
  EDIT_SINGLE_BET: 'settle-sportbook-bet',
  EDIT_PARLAY_BET: 'settle-parlay-bet',

  // kpi routes
  GET_SPORTRADAR_BET_METRICS: 'get-betting-metrics',
  REFRESH_SPORTRADAR_BET_METRICS: 'refresh-betting-metrics',
  GET_TOTAL_NUM_USERS: 'get-total-users',
  GET_TOTAL_EMAIL_VERIFIED: 'get-email-status',
  GET_TOTAL_PLAID_VERIFIED: 'get-plaid-status',

  // admin routes
  CREATE_ADMIN: 'create-admin-user',
  EDIT_ADMIN: 'update-admin-permission',
  GET_ADMINS: 'get-admins',
};
